export default function() {
  return new Promise(resolve => {
    if (!window.kentico || !window.kentico.pageBuilder) {
      resolve();
    }

    document.addEventListener('kenticoSectionMounted', resolve);
  });
}
